import { CheckCircle2, Clock3, DollarSign, LineChart } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { hospitalDashboardData } from "../../data/hospitalDashboard";
import type { HospitalDashboardViewData } from "../../api/mapHospitalDashboard";
import { cn } from "@/shared/lib/cn";

const rows = [
  { key: "totalBilled", icon: DollarSign, iconClassName: "text-purple" },
  { key: "paid", icon: CheckCircle2, iconClassName: "text-green" },
  { key: "pending", icon: Clock3, iconClassName: "text-yellow" },
  { key: "validationRate", icon: LineChart, iconClassName: "text-teal" },
] as const;

export function HospitalFinancialIndicators({
  data = hospitalDashboardData,
}: {
  data?: HospitalDashboardViewData;
}) {
  const { t } = useTranslation();
  const labels = t.safecheck.dashboard.hospitalBoard.financials;
  const { financials } = data;

  return (
    <div className="theme-card p-5">
      <h3 className="mb-5 text-sm font-semibold text-foreground">{labels.title}</h3>
      <div className="space-y-4">
        {rows.map((row) => {
          const Icon = row.icon;
          const value = financials[row.key];

          return (
            <div
              key={row.key}
              className="flex items-center justify-between gap-4 border-b border-border pb-4 last:border-b-0 last:pb-0"
            >
              <span className="flex items-center gap-3 text-sm text-muted-foreground">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-card-muted">
                  <Icon size={16} className={cn(row.iconClassName)} />
                </span>
                {labels[row.key]}
              </span>
              <span className="text-sm font-semibold text-foreground">{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
